export function setColumnSort(args, key) {
  // if (args[key]) {
  //   args[key] = args[key] == 'asc' ? 'desc' : 'asc';
  // }

  args.orderBy = key;
  if (args['sort']) {
    args['sort'] = args['sort'] == 'asc' ? 'desc' : 'asc';
  }

  return { ...args };
}

export function getMinSec(args) {
  // if (args > 9999) {
  //   return '';
  // }
  var hour =
    parseInt(args / 3600) < 10
      ? '0' + parseInt(args / 3600)
      : parseInt(args / 3600);
  var min =
    parseInt((args % 3600) / 60) < 10
      ? '0' + parseInt((args % 3600) / 60)
      : parseInt((args % 3600) / 60);
  var sec = args % 60 < 10 ? '0' + (args % 60) : args % 60;
  // return hour + ':' + min + ':' + sec;
  return min + ':' + sec;
}
